import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { UtilService } from '@services/util.service';
import { utils } from 'protractor';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
})

export class ReportsComponent implements OnInit {
  utilService: UtilService;
  constructor(private _utilService: UtilService, @Inject(DOCUMENT) public document: Document) {
    this.utilService = _utilService;
  }
  eventoURLPowerBISunscription: Subscription;
  ngOnInit(): void {
    this.utilService.funcaoObterVersao(null);
    //setInterval(this.functionAtualizarRelatorio, 10 * 50000);
    if (this?.utilService?.urlPowerBI) {
      this.functionAtualizarRelatorio();
    }

    setInterval(this.functionAtualizarRelatorio, 5 * 60 * 1000);
    this.eventoURLPowerBISunscription = this.utilService._eventoURLPowerBI.subscribe((x) => {
      this.functionAtualizarRelatorio();
    });
  }

  functionAtualizarRelatorio = () => {
    var referenciaElementoTestado = this.document.getElementById("iframeUrano") as HTMLIFrameElement;

    referenciaElementoTestado.src = this.utilService.urlPowerBI;
  }
}
